import React from 'react';
import { formatPortalReleaseAddedAt, portalReleaseToDate } from '../../utils/portalReleaseDateFormat';

type DeliverableLatestVersionCellProps = {
  releaseVersionIndex?: number;
  releasedAt?: Date | { toDate?: () => Date };
};

export const DeliverableLatestVersionCell: React.FC<DeliverableLatestVersionCellProps> = ({
  releaseVersionIndex,
  releasedAt,
}) => {
  const versionLabel =
    typeof releaseVersionIndex === 'number' ? `v${releaseVersionIndex}` : '—';
  const date = portalReleaseToDate(releasedAt);
  const addedLabel = formatPortalReleaseAddedAt(releasedAt);

  return (
    <div className="cps-deliverable-latest">
      <span className="cps-deliverable-version">{versionLabel}</span>
      {addedLabel && date ? (
        <time className="cps-deliverable-latest-date" dateTime={date.toISOString()}>
          {addedLabel}
        </time>
      ) : null}
    </div>
  );
};

export default DeliverableLatestVersionCell;
